import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpenFront: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderOpenFront"><Path d="M21.8076 20H2.19043L0.261719 11H23.7363L21.8076 20Z" fill="currentColor"/><Path d="M12.4131 5H21.999V9H1.99902V3H10.4131L12.4131 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderOpenFront;
